<template>
  <v-card color="tw-mt-4">
    <v-container>
      <!-- Documentation button -->
      <DocumentationDialogue class="tw-inline" path="manager/moderation/response" :key="$i18n.locale"/>

      <span v-if="review.moderate === 0" class="sr-title">
        {{ $t("dashboard.reviewsModeration.response.title") }}
      </span>
      <span v-else class="sr-title">
        {{ $t("dashboard.reviewsModeration.response_done.title") }}
      </span>

      <!-- Content of the response card -->
      <v-card-text>
        <v-stepper v-model="step" class="elevation-0">
          <v-stepper-items>
            <!-- Step 2 => Make a response -->

            <v-stepper-content :step="1" class="pa-0">
              <v-tabs vertical>
                <v-tab style="justify-content: normal;">
                  <v-icon left>mdi-account</v-icon>
                  {{ $t("dashboard.reviewsModeration.tabs.response") }}
                </v-tab>
                <v-tab style="justify-content: normal;" >
                  <v-icon left>mdi-account</v-icon>
                  {{ $t("dashboard.reviewsModeration.tabs.gift") }}
                </v-tab>
                <v-tab style="justify-content: normal;" >
                  <v-icon left>mdi-account</v-icon>
                  {{ $t("dashboard.reviewsModeration.tabs.author") }}
                </v-tab>
                <v-tab style="justify-content: normal;" :disabled="!review_data.from_order">
                  <v-icon left>mdi-account</v-icon>
                  {{ $t("dashboard.reviewsModeration.tabs.order") }}
                </v-tab>
                <v-tab style="justify-content: normal;">
                  <v-icon left>mdi-account</v-icon>
                  {{ $t("dashboard.reviewsModeration.tabs.hashtag") }}
                </v-tab>

                <v-tab-item sh="tab-item-message">
                  <v-card style="margin-left: 10px;">
                    <v-card-title>
                      {{ $t("dashboard.reviewsModeration.response.message") }}
                    </v-card-title>
                    <v-card-text>
                      <v-row id="part_response">
                        <v-col cols="12">
                          <v-textarea outlined :label="$t('dashboard.reviewsModeration.response.message_help')" v-model="response.message" flat name="response" no-resize />
                        </v-col>
                      </v-row>
                      <v-row id="part_pertinence_locale">
                        <v-col cols="6" style="margin-bottom: 5px;">
                          <v-select
                              v-model="review_data.locale"
                              :label="$t('dashboard.reviewsModeration.response.locale')"
                              :items="localeItems"
                              item-value="k"
                              item-text="v"
                          />
                        </v-col>
                        <v-col cols="6" align-self="end">
                          <v-slider
                              v-model="pertinence"
                              :label="$t('dashboard.reviewsModeration.response.pertinence')"
                              :thumb-color="pertinenceColor"
                              color="grey darken-1"
                              max="9"
                              min="1"
                              thumb-label="always"
                              thumb-size="20"
                              track-color="grey lighten-1"
                          />
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item sh="tab-item-gift">
                  <v-card style="margin-left: 10px;">
                    <v-card-title>
                      <v-icon color="blue" left x-small>fa-gift</v-icon>
                      {{ $t("dashboard.reviewsModeration.response.context.with_gift") }}
                    </v-card-title>
                    <v-card-text>
                      <v-row id="part_with_gift">
                        <v-col cols="6" style="padding-top: 0;">
                          <v-radio-group v-model="review_data.with_gift" row style="padding-left: 30px;">
                            <v-radio :value="false" :label="$t('dashboard.reviewsModeration.response.context.with_gift_false')"></v-radio>
                            <v-radio :value="true" :label="$t('dashboard.reviewsModeration.response.context.with_gift_true')"></v-radio>
                          </v-radio-group>
                        </v-col>
                        <v-col v-if="review_data.with_gift" cols="6" style="padding-top: 0;">
                          <v-card>
                            <v-card-text>
                              <v-text-field
                                  :label="$t('dashboard.reviewsModeration.response.context.gift_description')"
                                  v-model="review_data.gift_description"
                                  hide-details="auto"
                              ></v-text-field>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item sh="tab-item-order">
                  <v-card style="margin-left: 10px;">
                    <v-card-title>
                      <v-icon color="blue" left x-small>fa-user</v-icon>
                      {{ $t("dashboard.reviewsModeration.response.context.from_order") }}
                    </v-card-title>
                    <v-card-text>
                      <v-row id="part_from_order" >
                        <v-col cols="12">
                          <span class="font-weight-bold">

                          </span><br>
                          <v-radio-group v-model="review_data.from_order" row style="padding-left: 30px;">
                            <v-radio :value="false" :label="$t('dashboard.reviewsModeration.response.context.from_order_false')"></v-radio>
                            <v-radio :value="true" :label="$t('dashboard.reviewsModeration.response.context.from_order_true')"></v-radio>
                          </v-radio-group>
                        </v-col>
                        <v-col v-if="review_data.from_order" cols="12">
                          <v-card>
                            <v-card-title>{{ $t("dashboard.reviewsModeration.response.context.order_mandatory_info") }}</v-card-title>
                            <v-card-text>
                              <v-text-field
                                  type="date"
                                  :label="$t('dashboard.reviewsModeration.response.context.order_date')"
                                  v-model="review_data.order_date"
                                  hide-details="auto"
                              ></v-text-field>
                              <v-text-field
                                  :label="$t('dashboard.reviewsModeration.response.context.order_number')"
                                  v-model="review_data.order_number"
                                  hide-details="auto"
                              ></v-text-field>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item sh="tab-item-order-info">
                  <v-card style="margin-left: 10px;">
                    <v-card-title>
                      <v-icon color="blue" left x-small>fa-shopping-cart</v-icon>
                      {{$t("dashboard.reviewsModeration.response.context.order_optional_info")}}
                    </v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-col cols="6" style="padding-top: 0;">
                          <v-text-field
                              type="date-local"
                              :label="$t('dashboard.reviewsModeration.response.context.order_item_code')"
                              v-model="review_data.order_item_code"
                              hide-details="auto"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6" style="padding-top: 0;">
                          <v-text-field
                              :label="$t('dashboard.reviewsModeration.response.context.order_item_desc')"
                              v-model="review_data.order_item_desc"
                              hide-details="auto"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <b>{{ $t("dashboard.reviewsModeration.response.context.order_item_type") }}</b>
                          <v-radio-group v-model="review_data.order_item_type" row style="padding-left: 30px;">
                            <v-radio value="product" :label="$t('dashboard.reviewsModeration.response.context.order_item_type_product')"></v-radio>
                            <v-radio value="service" :label="$t('dashboard.reviewsModeration.response.context.order_item_type_service')"></v-radio>
                          </v-radio-group>
                        </v-col>
                        <v-col v-if="review_data.order_item_type==='service'" cols="6">
                            <span class="font-weight-bold">{{ $t("dashboard.reviewsModeration.response.context.order_info_type_service") }}</span><br>
                            <v-text-field
                                type="date"
                                :label="$t('dashboard.reviewsModeration.response.context.order_service_begin')"
                                v-model="review_data.order_service_begin"
                                hide-details="auto"
                            ></v-text-field>
                            <v-text-field
                                type="date"
                                :min="review_data.order_service_begin"
                                :label="$t('dashboard.reviewsModeration.response.context.order_service_end')"
                                v-model="review_data.order_service_end"
                                hide-details="auto"
                            ></v-text-field>
                          </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item sh="tab-item-hashtag">
                  <v-card style="margin-left: 10px;">
                    <v-card-title>
                      <v-icon color="blue" left x-small>fa-hashtag</v-icon>
                      {{ $t("dashboard.reviewsModeration.response.context.hashtag") }}
                    </v-card-title>
                    <v-card-text>
                      <v-row id="part_hashtag">
                        <v-col cols="6" style="padding-top: 0;">
                          <v-text-field
                              autocapitalize="characters"
                              :label="$t('dashboard.reviewsModeration.response.context.hashtag_help')"
                              v-model="review_data.hashtag"
                              hide-details="auto"
                              :onchange="cleanchashtag()"
                              prepend-inner-icon="small fa-hashtag"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
              </v-tab-item>
              </v-tabs>

              <div class="tw-mt-4">
                <v-btn class="tw-w-1/3 tw-mx-2" color="primary" small @click="publish">
                  {{ $t("dashboard.reviewsModeration.response.buttons.publish") }}
                </v-btn>
                <v-btn class="tw-w-1/3 tw-mx-2" color="primary" small @click="step = 2">
                  {{ $t("dashboard.reviewsModeration.response.buttons.report") }}
                </v-btn>
              </div>
            </v-stepper-content>

            <!-- Step 2 => Report an alter on the review -->
            <v-stepper-content :step="2" class="pa-0">
              <span class="font-weight-bold">
                {{ $t("dashboard.reviewsModeration.response.report.title") }}
              </span>
              <v-select
                v-model="reason"
                :items="reasons"
                :label="$t('dashboard.reviewsModeration.response.report.label')"
                class="mt-4"
                item-text="text"
                item-value="value"
              />
              <v-btn class="mt-2 mr-4" small @click="step = 1">
                {{ $t("dashboard.reviewsModeration.response.buttons.back") }}
              </v-btn>
              <v-btn :disabled="reason === 0" class="mt-2" color="primary" small @click="report">
                {{ $t("dashboard.reviewsModeration.response.buttons.report") }}
              </v-btn>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card-text>
    </v-container>
  </v-card>
</template>

<script>
import { Types as TypesDialog } from "../../../../store/modules/dialog"
import { Types as TypesPublications } from "../../../../store/modules/publications"
import { Types as TypesSnackbar } from "@/store/modules/snackbar"

export default {
  name: "response",
  props: {
    review: { required: true, default: {} },
    response: { required: true, default: { message: "" } },
  },
  data: () => ({
    tab: '',
    edit: false,
    pertinence: 5,
    reasons: [],
    reason: 0,
    step: 1,
    review_data: {
      locale: null,
      from_order: '',
      order_date: '',
      order_number: '',
      order_item_type: '',
      order_item_code: '' ,
      order_item_desc: '' ,
      order_service_begin: '' ,
      order_service_end: '',
      with_gift: '',
      hashtag: '',
      gift_description: '',
      solicitation_id: null,
    },
    localeItems: [],
  }),
  beforeDestroy() {
    if (this.locked) {
      this.free().then(() => {
        this.locked = false
      })
    }
  },
  created() {
    this.review_data.locale = null
    this.review_data.from_order = false
    this.review_data.order_date = '';
    this.review_data.order_number = '';
    this.review_data.order_item_type = '';
    this.review_data.order_item_code = '';
    this.review_data.order_item_desc = '';
    this.review_data.order_service_begin = '';
    this.review_data.order_service_end = '';
    this.review_data.with_gift = false;
    this.review_data.gift_description = '';
    this.review_data.solicitation_id = null;
    this.localeItems = [
      { k: 'fr', v: this.$t('locales.fr') },
      { k: 'en', v: this.$t('locales.en') },
      { k: 'de', v: this.$t('locales.de') },
      { k: 'es', v: this.$t('locales.es') },
      { k: 'it', v: this.$t('locales.it') },
      { k: 'xx', v: this.$t('locales.xx') },
    ]
  },
  mounted() {
    let details_json = JSON.parse(this.review.details_json)
    this.review_data.locale = this.review.locale
    this.review_data.from_order = this.review.from_order===1
    if(details_json) {
      if(details_json.order_date) {
        this.review_data.order_date = details_json.order_date;
      }
      if(details_json.order_number) {
        this.review_data.order_number = details_json.order_number;
      }
      if(details_json.order_item_type) {
        this.review_data.order_item_type = details_json.order_item_type;
      }
      if(details_json.order_item_code) {
        this.review_data.order_item_code = details_json.order_item_code;
      }
      if(details_json.order_item_desc) {
        this.review_data.order_item_desc = details_json.order_item_desc;
      }
      if(this.review_data.order_item_type==='service') {
        if(details_json.order_service_begin) {
          this.review_data.order_service_begin = details_json.order_service_begin;
        }
        if(details_json.order_service_end) {
          this.review_data.order_service_end = details_json.order_service_end;
        }
      }
      if(details_json.gift_description) {
        this.review_data.gift_description = details_json.gift_description;
      }
    }
    this.review_data.with_gift = this.review.with_gift===1;
    this.review_data.hashtag = this.review.hashtag;
    this.review_data.solicitation_id = this.review.solicitation_id;
    console.log(this.review_data)
    this.reasons = [
      {
        value: 1,
        text: this.$t("dashboard.reviewsModeration.response.report.1"),
      },
      {
        value: 2,
        text: this.$t("dashboard.reviewsModeration.response.report.2"),
      },
      {
        value: 3,
        text: this.$t("dashboard.reviewsModeration.response.report.3"),
      },
      {
        value: 4,
        text: this.$t("dashboard.reviewsModeration.response.report.4"),
      },
      {
        value: 5,
        text: this.$t("dashboard.reviewsModeration.response.report.5"),
      },
      {
        value: 6,
        text: this.$t("dashboard.reviewsModeration.response.report.6"),
      },
      {
        value: 7,
        text: this.$t("dashboard.reviewsModeration.response.report.7"),
      },
      {
        value: 8,
        text: this.$t("dashboard.reviewsModeration.response.report.8"),
      },
      {
        value: 9,
        text: this.$t("dashboard.reviewsModeration.response.report.9"),
      },
    ]
  },
  computed: {
    updateDate() {
      return this.$moment(this.response.updated_at).from()
    },
    pertinenceColor() {
      switch (this.pertinence) {
        case 1:
          return "red darken-3"
        case 2:
          return "red"
        case 3:
          return "orange darken-3"
        case 4:
          return "orange"
        case 5:
          return "orange lighten-2"
        case 6:
          return "green darken-3"
        case 7:
          return "green darken-1"
        case 8:
          return "green"
        case 9:
          return "green lighten-2"
        default:
          return "grey"
      }
    },
},
  methods: {
    cleanchashtag() {
      if(this.review_data&&this.review_data.hashtag) {
        this.review_data.hashtag = this.review_data.hashtag.toUpperCase()
        this.review_data.hashtag = this.review_data.hashtag.replace(/[^A-Z-]./,'')
        this.review_data.hashtag = this.review_data.hashtag.replace(' ','')
      }
    },

    publish() {
      this.$store.dispatch(TypesDialog.actions.CONFIRM, {
        title: this.$t("dashboard.reviewsModeration.dialogs.publish.title"),
        message: this.$t("dashboard.reviewsModeration.dialogs.publish.text"),
        callback: () => {
          let review = this.review
          const user = this.$store.state.auth.user

          this.$axios
            .post("office/manager/response", {
              // Need to report the qualification here (40+qualification( 1-9 ))
              confidence: 40 + this.pertinence,
              review_id: this.review.id,
              user_id: user.id,
              database: this.review.database,
              response: this.response,
              from_order: this.review_data.from_order,
              order_date: this.review_data.order_date,
              order_number: this.review_data.order_number,
              order_item_type: this.review_data.order_item_type,
              order_item_code: this.review_data.order_item_code,
              order_item_desc: this.review_data.order_item_desc,
              order_service_begin: this.review_data.order_service_begin,
              order_service_end: this.review_data.order_service_end,
              with_gift: this.review_data.with_gift,
              gift_description: this.review_data.gift_description,
              hashtag: this.review_data.hashtag,
              locale: this.review_data.locale,
            })
            .then(response => {
              let reviews = [...this.$store.state.publications.reviews]
              const index = reviews.findIndex(r => r.id === this.review.id && r.database === this.review.database)

              reviews[index]["response"] = response.data.data
              // Dispatch changes
              this.$store.dispatch(TypesPublications.actions.REVIEWS, reviews)

              this.$axios
                .post("office/manager/response/moderate", {
                  // Need to report the qualification here (40+qualification( 1-9 ))
                  confidence: 40 + this.pertinence,
                  relevant: this.pertinence,
                  review_id: this.review.id,
                  database: this.review.database,
                  response: this.response,
                })
                .then(response => {
                  let reviews = [...this.$store.state.publications.reviews]
                  const index = reviews.findIndex(r => r.id === this.review.id && r.database === this.review.database)
                  review = { ...reviews[index], ...response.data.data }
                  reviews[index] = review

                  this.$emit("update:moderate", reviews[index]["moderate"])
                  this.$emit("confidence", 40 + this.pertinence)

                  // Dispatch changes
                  this.$store.dispatch(TypesPublications.actions.REVIEWS, reviews)
                  this.step = 1
                  this.$store.dispatch(TypesSnackbar.actions.PUSH_MESSAGE, {
                    lines: this.$t("dashboard.reviewsModeration.dialogs.publish.success"),
                    config: { timeout: 1000 * 6, color: "success" },
                  })
                })
            })
        },
      })
    },
    report() {
      this.$store.dispatch(TypesDialog.actions.CONFIRM, {
        title: this.$t("dashboard.reviewsModeration.dialogs.report.title"),
        message:
          this.$t("dashboard.reviewsModeration.dialogs.report.text") +
          `<br>` +
          `<strong>${this.reasons.find(r => r.value === this.reason).text}</strong>`,
        callback: () => {
          let review = this.review
          this.$axios
            .post("office/manager/response/moderate", {
              //Need to provide a reason to report the review (0+reason( 1-9 ))
              confidence: this.reason,
              review_id: this.review.id,
              database: this.review.database,
              response: this.response,
            })
            .then(response => {
              let reviews = [...this.$store.state.publications.reviews]
              const index = reviews.findIndex(r => r.id === this.review.id && r.database === this.review.database)

              review = { ...reviews[index], ...response.data.data }
              reviews[index] = review

              this.$emit("confidence", this.reason)
              this.$emit("update:moderate", reviews[index]["moderate"])

              // Dispatch changes
              this.$store.dispatch(TypesPublications.actions.REVIEWS, reviews)
              this.step = 1
              this.$store.dispatch(TypesSnackbar.actions.PUSH_MESSAGE, {
                lines: this.$t("dashboard.reviewsModeration.dialogs.report.success"),
                config: { timeout: 1000 * 6, color: "success" },
              })
            })
        },
      })
    },
    remove() {
      this.$store.dispatch(TypesDialog.actions.CONFIRM, {
        title: this.$t("dashboard.reviewsModeration.dialogs.remove.title"),
        message: this.$t("dashboard.reviewsModeration.dialogs.remove.text"),
        callback: () => {
          this.free().then(() => {
            this.edit = false
            this.locked = false

            this.$axios.delete("office/manager/response", {
              data: {
                database: this.review.database,
                response: this.review.response,
              },
            })

            this.$emit("remove")
          })
        },
      })
    },
  },
}
</script>
